import Api from '@/api/Api'
import store from '../store'

export default {
  async getPricing () {
    return store.dispatch('checkResponseApi', await Api().get('pricing/current'))
  },
}



// WEBPACK FOOTER //
// ./src/api/TreeSoftService.js